import { SxProps, Theme } from '@mui/material';
import { GLOBAL_MARGIN_HORIZONTAL } from 'src/app/constants';

export const screenContainer: SxProps<Theme> = {
  flex: 1,
  display: 'flex',
  padding: GLOBAL_MARGIN_HORIZONTAL,
  bgcolor: theme => theme.palette.background.default,
};

export const contentBox: SxProps<Theme> = {
  width: '100%',
  paddingTop: GLOBAL_MARGIN_HORIZONTAL * 2,
};

export const aiNoticeCard: SxProps<Theme> = {
  p: { xs: 2.5, md: 3 },
  mb: 2,
  borderRadius: 3,
  border: theme => `1px solid ${theme.palette.divider}`,
  background:
    'linear-gradient(135deg, rgba(42,87,238,0.08) 0%, rgba(42,87,238,0.02) 100%)',
};

export const hiddenFileInput: SxProps<Theme> = {
  display: 'none',
};

export const toastAlert: SxProps<Theme> = {
  width: '100%',
};

export const card: SxProps<Theme> = {
  p: { xs: 2, md: 3 },
  borderRadius: 3,
  border: theme => `1px solid ${theme.palette.divider}`,
};

export const listCard: SxProps<Theme> = {
  ...card,
  mt: 2,
};

export const listDivider: SxProps<Theme> = {
  mb: 1.5,
};

export const categoryField: SxProps<Theme> = {
  minWidth: 160,
};

export const amountField: SxProps<Theme> = {
  minWidth: 140,
};

export const paymentField: SxProps<Theme> = {
  minWidth: 140,
};

export const addButton: SxProps<Theme> = {
  whiteSpace: 'nowrap',
};
